module.exports = __webpack_public_path__ + "media/images/writer/home/home-03@3x-e2b9943654d3d4a176f9508bea6df9a5.png";